import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Our Team', path: '/team' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' }
  ];

  const staffResources = [
    { name: 'ADP Workforce', url: 'https://online.adp.com/signin/v1/?APPID=wfncloud&productId=lehigh-site-deploy&returnURL=https://workforcenow.cloud.adp.com/&callingAppId=wfncloud&TARGET=-SM-https://workforcenow.cloud.adp.com/theme/index.html' },
    { name: 'Relias Training', url: 'https://login.reliaslearning.com/login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Drlms-legacy%26response_mode%3Dform_post%26response_type%3Dcode%2520id_token%26scope%3Dopenid%2520offline_access%2520impersonator%2520saml%2520usersapi%2520assessmentsapi%2520learningapi%2520identityapi%2520learning-reporting-api%2520evaluationsapi%2520notification-delivery-service-api%2520compliance-policermanager-service-api%2520workflow-service-api%2520compliance-incident-service-api%26state%3DOpenIdConnect.AuthenticationProperties%253DtYqZTPeyRDkdOoWMxLsj403yBvghHeodWYqFSiclFdBNZF_AW9ixU9nKKEyjX9zIhYliff3fF7sk4NMEBN3WscoxyW3BpyU29Qx8zG5uvgJpTSn3qgmwFSZ23LMiMNdoVvEvwh_oi4RhQtUW0idDNFZ8wc-q1jr4PYWJdbNwKsY%26nonce%3D638701356184010484.YTI2YjU1OWEtYTRhZC00ZWJjLWE2MjktMmZlNWU1M2Q5NjEzYzdmYmVmMmUtZTdlYi00YmY1LTgxMTItNDRiNmYxZjJiMzlm%26redirect_uri%3Dhttps%253A%252F%252Flehighhss.training.reliaslearning.com%26post_logout_redirect_uri%3Dhttps%253A%252F%252Flehighhss.training.reliaslearning.com%26acr_values%3DorgId%253A31713%2520' },
    { name: 'Therap Services', url: 'https://secure.therapservices.net/auth/login' }
  ];

  const services = [
    'Residential Support',
    'Personal Care',
    'Community Integration',
    'Daily Living Support',
    'Program Coordination'
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* About Section */}
          <div className="space-y-6">
            <img
              src="https://customer-assets.emergentagent.com/job_lehigh-hss-updated/artifacts/pdbn1to4_image.png"
              alt="Lehigh HSS Logo"
              className="h-16 w-auto"
            />
            <p className="text-gray-400 leading-relaxed">
              Empowering lives, fostering community and family support for individuals with intellectual and developmental disabilities.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors duration-300"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors duration-300"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2"
                  >
                    <span className="w-1 h-1 bg-amber-500 rounded-full"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Staff Resources */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Staff Resources</h3>
            <ul className="space-y-3">
              {staffResources.map((resource, index) => (
                <li key={index}>
                  <a
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2"
                  >
                    <span className="w-1 h-1 bg-amber-500 rounded-full"></span>
                    {resource.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-gray-400 flex items-center gap-2">
                  <span className="w-1 h-1 bg-amber-500 rounded-full"></span>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-1" />
                <span>
                  5920 Hamilton Blvd, Suite 108<br />
                  Allentown, PA 18106
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <a href="tel:4843503601" className="hover:text-amber-400 transition-colors">
                  (484) 350-3601
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <a href="mailto:info@lehigh-hss.com" className="hover:text-amber-400 transition-colors">
                  info@lehigh-hss.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Clock className="w-5 h-5 text-amber-500 flex-shrink-0 mt-1" />
                <span>
                  Mon - Fri: 9:00 AM - 6:00 PM<br />
                  Closed on Weekends
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Lehigh Human Support Services. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;